export type UploadProps = {
  onSubmit: any;
};

export enum Users {
  Admin = 'Admin',
  Participant = 'Participant',
}
